(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/session-time/assets/javascripts/session-time.js') >= 0) return;  svs.modules.push('/components/components/session-time/assets/javascripts/session-time.js'); "use strict";

(function (svs) {
  svs.components = svs.components || {};

  svs.components.session_time = svs.components.session_time || function () {
    var logger = svs.core.log.getLogger('components:session-time');

    var isInteger = Number.isInteger || function (value) {
      return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
    };

    var loginTimeStamp,
        sessionTimeMs,
        hasLogged = false;

    function updateSessionTimeMs(sesTimeMs) {
      var receivedSessionTimeMs = parseInt(sesTimeMs || 0, 10);

      if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
        if (isInteger(receivedSessionTimeMs) && receivedSessionTimeMs) {
          if (receivedSessionTimeMs < sessionTimeMs) {
            logger.warn("Received a decreased session time: ".concat(sessionTimeMs - receivedSessionTimeMs, " ms"));
          }

          sessionTimeMs = receivedSessionTimeMs;
          loginTimeStamp = Date.now() - sessionTimeMs;

          if (!hasLogged) {
            logger.debug("Received session time from jupiter: ".concat(Math.floor(sessionTimeMs / 60000), " m."));
            hasLogged = true;
            setTimeout(function () {
              hasLogged = false;
            }, 10000);
          }
        } else {
          logger.warn('Missing session time from jupiter');
        }
      }
    }


    function startPublishSessionTime() {
      svs.events.publish('/components/session_time/sessionTimeM', [getSessionTimeM()]);
      logger.debug("Calculated session time: ".concat(getSessionTimeM(), " m."));
      setTimeout(startPublishSessionTime, 30 * 1000);
    }


    function getSessionTimeM() {
      if (sessionTimeMs) {
        return Math.floor((Date.now() - loginTimeStamp) / (60 * 1000));
      }

      return sessionTimeMs;
    }


    function init() {
      if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
        updateSessionTimeMs(svs.core.jupiter.getSessionTimeMs() || 1); 

        svs.events.subscribe('/core/jupiter/sessionTimeMs', updateSessionTimeMs);
        startPublishSessionTime();
      } else {
        sessionTimeMs = 0;
      }
    }

    init();
    return {
      init: init,
      get: getSessionTimeM
    };
  }();
})(svs);
 })(window);